<div class="d-flex flex-column align-items-center">
  <div class="card mt-5 col-md-6 p-4 mr-0 p-gutter flex-auto max-w-[700px]">
    <div class="d-flex flex-column align-items-end" (click)="close()"> <span style="cursor: pointer;">&times;</span>
    </div>
    <h5>Assign Examiners for {{exam.examinationName}}</h5>
    <div class="row d-flex justify-content-center mb-3">
      <div class="col">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input mr-1" [(ngModel)]="reassignExistingExaminers"
              [ngModelOptions]="{ standalone: true }">
            <label class="custom-control-label" for="customCheck1">Reassign Existing Examiners</label>
          </div>
        </div>
      </div>

      <div class="col">
        <div class="form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input mr-1" [(ngModel)]="includeWrittenExamsOnly"
              [ngModelOptions]="{ standalone: true }">
            <label class="custom-control-label" for="customCheck1"> Include Written Exams Only</label>
          </div>
        </div>
      </div>
    </div>
    <button class="btn btn-primary btn-lg col-md-10" type="submit" [disabled]="!this.exam" (click)="runAssingExaminer()"> Assign Examiners
    </button>
  </div>
</div>